var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.withCommonHeader)?_c('div',{class:[
        'top-container-wrapper',
        {
            pc: _vm.isPC,
            'layout-cover': _vm.fixedTop && _vm.layout === _vm.LAYOUT.COVER
        }
    ]},[_c('body-teleport',{class:[
            'top-container',
            {
                pc: _vm.isPC,
                fixed: _vm.fixedTop
            }
        ],style:(_vm.wrapperStyle),attrs:{"needTeleport":_vm.fixedTop}},[(_vm.logoChild[0])?_c('inner-children-renderer',{staticClass:"top-container__logo",attrs:{"children":_vm.logoChild[0]}}):_vm._e(),_vm._v(" "),_c('flow-container',{staticClass:"right-flow-container",attrs:{"children":_vm.otherChildren}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }